export default __webpack_public_path__ + "static/media/cart-plus-solid.eac6e7f2.svg";